module.exports = __webpack_public_path__ + "static/media/everyone.1ccef8c9.jpg";